<template>
  <thead>
    <tr>
      <th class="tab-wid-80" colspan="4">
        №
        <br />п/п
      </th>
      <th class="tab-wid-550">Наименование документа</th>
      <th>Бумажный вид документа</th>
      <th></th>
      <th>Дата загрузки</th>
      <th v-if="documentConf.IS_RFRP_PROGRAM" style="width: 100px;" colspan="2">
        Акцепт РФРП
      </th>
      <th>Электронный вид</th>
      <th v-if="documentConf.isViewElectornAccept">Акцептант</th>
      <th v-if="documentConf.isViewElectornAccept">Дата акцепта</th>

      <th>Бумажный вид</th>
      <th>Комментарий</th>
      <th></th>
      <th v-if="documentConf.IS_RFRP_PROGRAM">
        Комментарий РФРП
      </th>
      <th v-if="documentConf.IS_RFRP_PROGRAM"></th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  </thead>
</template>

<script>
export default {
  props: ["documentConf"],
  name: "TableHead"
};
</script>

<style scoped></style>
